import path from 'path';
import { EnvVariables } from './envVariables';
import { RuleOs, RuleType } from './Rule';

export default class RuleExplanation {
  empty = false;
  text = '';
  samples: Array<{ os: RuleOs; text: string }> = [];
  warnings: string[] = [];

  constructor(dto: Partial<RuleExplanation>) {
    Object.assign(this, dto);
  }

  static fromRule({
    destinationPath = '',
    sourcePath = '',
    os,
    type,
  }: {
    destinationPath: string;
    os: RuleOs[];
    sourcePath: string;
    type: RuleType;
  }): RuleExplanation {
    if (type === 'delete') {
      return new RuleExplanation({ empty: true });
    }

    const isSrcDir = !path.basename(sourcePath).includes('.');
    const isDestDir = !path.basename(destinationPath).includes('.');

    const srcWithMask = isSrcDir ? path.join(sourcePath, '*') : sourcePath;

    const result = new RuleExplanation({
      text: `${operationNames[type]} {INSTALL_PATH}/${srcWithMask} to`,
      samples: [],
      warnings: [],
    });

    result.samples = os.map((selectedOs) => {
      const join = selectedOs === 'win32' ? win32Join : path.join;

      return {
        os: selectedOs,
        text: join(
          applyTemplates(destinationPath, selectedOs),
          isSrcDir ? '*' : '',
        ),
      };
    });

    if (!isSrcDir && isDestDir) {
      result.warnings.push(
        [
          'Looks like the source path is a file, ',
          'but the destination path is a directory. Do you mean ',
          `"${path.join(destinationPath, path.basename(sourcePath))}"?`,
        ].join(''),
      );
    }

    return result;
  }
}

const operationNames: Record<RuleType, string> = {
  copy: 'Copy',
  delete: 'Delete',
  move: 'Move',
};

function applyTemplates(destPath: string, os: RuleOs): string {
  return destPath.replaceAll(/{(\w+)}/g, (_, varName) => {
    const variableDefinition = EnvVariables.find((v) => v.name === varName);

    if (!variableDefinition) {
      return `\${${varName}}`;
    }

    const value = variableDefinition[`example_${os}`];
    return value || `\${${varName}}`;
  });
}

// path.win32 isn't available in a browser
function win32Join(...paths: string[]) {
  return path.join(...paths).replaceAll(/[/\\]+/g, '\\');
}
